var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "c-table-cell",
      attrs: { id: `violation-${_vm.data.fineOrBonusDeadlineCell.id}` },
    },
    [
      _c("div", { staticClass: "c-table__cell-value" }, [
        _vm._v(" " + _vm._s(_vm.data.fineOrBonusDeadlineCell.deadline) + " "),
      ]),
      _vm.isFined
        ? _c(
            "b-popover",
            {
              attrs: {
                target: `violation-${_vm.data.fineOrBonusDeadlineCell.id}`,
                triggers: "hover blur",
                placement: "bottom",
                container: "#app",
              },
            },
            [
              _vm._v(
                " Выписан штраф за отсутствие объяснительной в размере 100฿ "
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }